export default "__VITE_ASSET__p4Wrwq16__"